import * as React from "react";
const ArrowLeft = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={18} height={9} fill="none" {...props}>
    <path stroke="#fff" strokeLinecap="round" strokeWidth={1.5} d="M17.01 4.608H1.638m0 0L4.422 1.71M1.637 4.608l2.785 2.785" />
  </svg>
);
export default ArrowLeft;
